import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_FINISH:
      return fromJS(action.payload.scores || {});
    case actions.GET_ERROR:
      return fromJS({});
    case actions.CREATE_START:
      return state.set(action.payload.id, fromJS(action.payload.entity));
    case actions.CREATE_FINISH:
      return state.set(action.payload.id, fromJS(action.payload.entity));
    case actions.CREATE_ERROR:
      return state.delete(action.payload.id);
    case actions.DELETE_FINISH:
      return state.delete(action.payload.scoreId);
    case actions.UPDATE_FINISH:
      return state.update(action.payload.scoreId, score =>
        score.merge(fromJS(action.payload.entity))
      );
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/scores/reducers/entities.js